import { classNames } from "@ember-decorators/component";
import icon from "discourse/helpers/d-icon";
import periodTitle from "discourse/helpers/period-title";
import discourseComputed from "discourse/lib/decorators";
import DropdownSelectBoxHeaderComponent from "select-kit/components/dropdown-select-box/dropdown-select-box-header";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const PeriodChooserHeader = dt7948.c(class PeriodChooserHeader extends DropdownSelectBoxHeaderComponent {
  caretIcon(isExpanded) {
    return isExpanded ? "caret-up" : "caret-down";
  }
  static {
    dt7948.n(this.prototype, "caretIcon", [discourseComputed("selectKit.isExpanded")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <h2 class=\"selected-name\" title={{this.title}}>\n      {{periodTitle this.value showDateRange=true fullDay=this.selectKit.options.fullDay}}\n    </h2>\n\n    {{icon this.caretIcon class=\"caret-icon\"}}\n  ", {
      strictMode: true,
      scope: () => ({
        periodTitle,
        icon
      })
    }), this);
  }
}, [classNames("period-chooser-header", "btn-flat")]);
export default PeriodChooserHeader;